import { Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const CardHeader = () => {
	const { translate } = useLocales();

	return (
		<Stack gap={0.5} sx={{ p: 3 }}>
			<Typography variant={"h6"}>{translate("customization.title")}</Typography>
			<Typography variant='body2' color='text.secondary'>
				{translate("customization.description")}
			</Typography>
		</Stack>
	);
};

export default CardHeader;
